import { QATAR_DIAL_CODE } from '@fe/shared/Countries';
import { ChevronDown } from 'lucide-preact';
import { useContext } from 'preact/hooks';

import { CountryCodeSelectorContext } from '@/context/CountryCodeSelectorContext';

import FlagIcon from './FlagIcon';

export default function CountryCodeMenuButton() {
  const { selectedCountry } = useContext(CountryCodeSelectorContext);

  return (
    <button
      type='button'
      className='flex w-full items-center justify-between rounded-md border bg-white px-3 py-2 text-sm shadow-sm'
    >
      <span className='flex items-center gap-2'>
        <FlagIcon countryAcronym={selectedCountry?.isoCode ?? 'qa'} />
        {'  '}
        <span>{selectedCountry?.dialCode ?? QATAR_DIAL_CODE}</span>
        <ChevronDown className='h-4 w-4' fill='currentColor' />
      </span>
    </button>
  );
}
